module.exports = __webpack_public_path__ + "img/Omg_04.a48f9f2b.png";